import { EntityDefinition } from "ips/ac/model/types/EntityDefinition";

const UserDefinition: EntityDefinition = {
  ENTITY: "User",
  ENTITY_SET: "Users",
  DETAIL: "UserDetail",
};
export default UserDefinition;
